/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import classNames from "classnames";
import useMenuStore from "stores/menuStore";
import { MENU_BEHAVIOUR } from "../../utils/constant";

const NavIconMenu = () => {
  const { pinButtonEnable, behaviour, menuChangeBehaviour } = useMenuStore();

  const onPinButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (pinButtonEnable) {
      menuChangeBehaviour(
        behaviour === MENU_BEHAVIOUR.Pinned
          ? MENU_BEHAVIOUR.Unpinned
          : MENU_BEHAVIOUR.Pinned
      );
    }
    return false;
  };
  const onDisabledPinButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <ul className="list-unstyled list-inline text-center menu-icons">
        <li className="list-inline-item">
          <a
            href="#/"
            id="pinButton"
            onClick={
              pinButtonEnable ? onPinButtonClick : onDisabledPinButtonClick
            }
            className={classNames("pin-button", { disabled: !pinButtonEnable })}
          />
        </li>
      </ul>
    </>
  );
};

export default React.memo(NavIconMenu);
